import { useEffect } from 'react';
export const UseCareers = props => { 
    const {fetchCareers,careers} =props
    useEffect(()=>{
        if(careers.length===0)
        fetchCareers()
    },[fetchCareers,careers])
} 